import { Injectable } from '@angular/core';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Filter } from '@app/modules/reports/models/data.type';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

type balanceSheetData = {
  vufid: number;
  vault_form_id: number;
  fid: number;
  is_liability: number;
  is_asset: number;
  attribute_class: string;
  attribute_sub_class: string;
  effective_date: string;
  value: string;
};

type cashFlowData = {
  vufid: number;
  vault_form_id: number;
  type: string;
  effective_date: string;
  category_parent: string;
  category: string;
  value: string;
  no_of_records: string;
};

type serverResponceBalanceSheet = {
  status: number;
  data: balanceSheetData[];
};

type serverResponceCashFlow = {
  status: number;
  data: cashFlowData[];
};

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private REPORT_API_URL = 'api/report/report';
  // balance sheet report filter
  balanceReportFilterValues: Filter;
  balanceReportFilterValuesChange: Subject<Filter> = new Subject<Filter>();
  // cash flow sheet report filter
  cashFlowReportFilterValues: Filter;
  cashFlowReportFilterValuesChange: Subject<Filter> = new Subject<Filter>();

  constructor(private readonly httpService: AmplifyHttpClient, private router: Router, private http: HttpClient) {}
  /**
   * Method : Get balance sheet report data
   * @returns :
   */
  public toggleRuleSidebar: BehaviorSubject<string> = new BehaviorSubject('');
  public toggleRuleSidebarHandler(payload: any) {
    this.toggleRuleSidebar.next(payload);
  }
  getBalanceSheetReportData(type: string, userId: number, period: string, vaultUserFolderId: number): Observable<balanceSheetData[]> {
    const url = `api/common/report-data`;
    return this.httpService
      .post<serverResponceBalanceSheet>(url, {
        type: type,
        user_id: userId,
        period: period,
        vault_user_folder_id: vaultUserFolderId,
      })
      .pipe(
        map((response: serverResponceBalanceSheet) => {
          if (response.status == 200) {
            return response.data;
          }
        })
      );
  }

  /**
   * Method : Get Position report class list
   * @returns :
   */
  getreportAssetsClass() {
    const url = `api/report/asset-class-list`;
    return this.httpService.get<serverResponceCashFlow>(url).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  /**
   * Method : create group
   * @returns :
   */
  createReportAssetsClass(data) {
    const url = `api/report/report-asset-map-group`;
    return this.httpService.post<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  /**
   * Method : get asset class list
   * @returns :
   */
  getReportAssetsClass(data) {
    const url = `api/report/asset-map-group-asset-class`;
    return this.httpService.post<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  /**
   * Method : post url from upload assets map
   * @returns :
   */
  postUploadedUrlForMap(data) {
    const url = `api/report/asset-map-owners-profile`;
    return this.httpService.post<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  /**
   * Method : patch url from upload assets map
   * @returns :
   */
  updateUploadedUrlForMap(data) {
    const url = `api/report/asset-map-owners-profile`;
    return this.httpService.patch<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  /**
   * Method : move asset class list
   * @returns :
   */
  moveReportAssetsClass(data) {
    const url = `api/report/move-asset-to-group`;
    return this.httpService.post<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  /**
   * Method : update asset group
   * @returns :
   */
  updateReportAssetMapGroup(data) {
    const url = `api/report/report-asset-map-group`;
    return this.httpService.patch<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  /**
   * Method : delete asset group
   * @returns :
   */
  deleteReportAssetMapGroup(id) {
    const url = `api/report/report-asset-map-group/${id}`;
    return this.httpService.delete<serverResponceCashFlow>(url).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  /**
   * Method : hide report asset items
   * @returns :
   */
  assetMapHide(data) {
    const url = `api/report/asset-map-hide`;
    return this.httpService.post<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  /**
   * Method : hide report asset items
   * @returns :
   */
  assetMapUnHide(data) {
    const url = `api/report/asset-map-unhide`;
    return this.httpService.post<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  /**
   * Method : Get Position report data
   * @returns :
   */
  getPositionReporthierachyData(data) {
    const url = `api/report/report-execution-balance-position-hierachy`;
    return this.httpService.post<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  /**
   * Method : Get Position report data
   * @returns :
   */
  getPositionReportData(data) {
    const url = `api/report/report-execution-balance-position-register`;
    return this.httpService.post<serverResponceCashFlow>(url, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  /**
   * Method : Get Position Filter report data
   * @returns :
   */
  getPositionFilterReportData(id) {
    const url = `api/report/report-execution-balance-position-register-class-list/${id}`;
    return this.httpService.get<serverResponceCashFlow>(url).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  /**
   * Method : Get cash flow report data
   * @returns :
   */
  getCashFlowReportData(type: string, userId: number, period: string, vaultUserFolderId: number): Observable<cashFlowData[]> {
    const url = `api/common/report-data`;
    return this.httpService
      .post<serverResponceCashFlow>(url, {
        type: type,
        user_id: userId,
        period: period,
        vault_user_folder_id: vaultUserFolderId,
      })
      .pipe(
        map((response: serverResponceCashFlow) => {
          if (response.status == 200) {
            return response.data;
          }
        })
      );
  }

  /**
   * Method to change balance report filter values
   */
  changeBalanceReportFilterValues(value: Filter) {
    this.balanceReportFilterValuesChange.next(value);
  }

  /**
   * Method to get balance report filter values
   */
  getBalanceReportFilterValues(): Observable<Filter> {
    return this.balanceReportFilterValuesChange.pipe(map((res) => res));
  }

  /**
   * Method to change cash flow report filter values
   */
  changeCashFlowReportFilterValues(value: Filter) {
    this.cashFlowReportFilterValuesChange.next(value);
  }

  /**
   * Method to get cash flow report filter values
   */
  getCashFlowReportFilterValues(): Observable<Filter> {
    return this.cashFlowReportFilterValuesChange.pipe(map((res) => res));
  }

  getReport(): Observable<any> {
    let url = `${this.REPORT_API_URL}`;
    if (this.router.url.includes('workspace')) {
      const parseUrl = this.router.url.split('/');
      url = url + `/${parseUrl[2]}`;
    }
    return this.httpService.get<any>(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  startReportExecution(request): Observable<any> {
    return this.httpService.post<any>(`api/report/report-execution`, request, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportExecutionStatus(id): Observable<any> {
    return this.httpService.get<any>(`api/report/report-execution-status-updated-date/${id}`, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getGraphData(id, class_type, type): Observable<any> {
    return this.httpService
      .get<any>(`api/report/report-execution-latest-balance-asset-sub-class/${id}/${class_type}/${type}`, loaderTypes.mainAnimation)
      .pipe(
        map((response: any) => {
          if (response.status == 200) {
            return response.data;
          } else {
            return response;
          }
        })
      );
  }
  getReportExecutionList(id, type): Observable<any> {
    return this.httpService.get<any>(`api/report/report-execution-latest-balance-asset-class/${id}/${type}`, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportExecutionBalanceAssetClass(id, type, label_counter = 0): Observable<any> {
    let url = `api/report/report-execution-balance-asset-class/${id}/${type}`;
    if (label_counter > 0) {
      url = url + `/${label_counter}`;
    }
    return this.httpService.get<any>(url, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteAlreadyAddedVaultList(id): Observable<any> {
    return this.httpService.delete<any>(`api/report/report-source/${id}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }
  getAlreadyAddedVaultList(id): Observable<any> {
    return this.httpService.get<any>(`api/report/report-source/${id}`, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportExecutionBalanceNetWorthStatus(id, count = 0): Observable<any> {
    let url = `api/report/report-execution-balance-net-worth/${id}`;
    if (count > 0) {
      url = url + `/${count}`;
    }
    return this.httpService.get<any>(url, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportExecutionOwenrship(id): Observable<any> {
    const url = `api/report/report-execution-ownership-map`;
    const body = {
      report_execution_id: id,
    };
    return this.httpService.post<any>(url, body, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportExecutionOwenrshipPositionRegister(body): Observable<any> {
    const url = `api/report/report-execution-ownership-map-position-register`;
    return this.httpService.post<any>(url, body, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateReportOwnershipMapExclude(body): Observable<any> {
    return this.httpService.post<any>(`api/report/report-ownership-map-exclude`, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateReportOwnershipMapInclude(body): Observable<any> {
    return this.httpService.post<any>(`api/report/report-ownership-map-include`, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createReport(request): Observable<any> {
    return this.httpService.post<any>(`${this.REPORT_API_URL}`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getCategoriesVendorAnalysis(id) {
    return this.httpService.get<any>(`api/report/cash-expense-category-list/${id}`, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  setReportExecutionBalancePositionRegisterActiveDeActive(request) {
    const url = `api/report/report-execution-balance-position-register-active-deactive`;
    return this.httpService.post(url, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  manageReportSource(request): Observable<any> {
    return this.httpService.post<any>(`${this.REPORT_API_URL}-source`, request, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  addMemberManageReportSource(request): Observable<any> {
    return this.httpService.post<any>(`api/report/add-one-member-report-source`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateReport(request, isShowLoader: boolean = true): Observable<any> {
    return this.httpService.patch<any>(`${this.REPORT_API_URL}`, request, isShowLoader ? loaderTypes.mainAnimation : loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getMemberFilterList(reportId): Observable<any> {
    return this.httpService
      .get<any>(`${this.REPORT_API_URL}-execution-balance-position-register-member-list/${reportId}`, null, loaderTypes.none)
      .pipe(
        map((response: any) => {
          if (response.status === 200) {
            return response.data;
          } else {
            return response;
          }
        })
      );
  }
  getReportCashAccountBalance(data): Observable<any> {
    return this.httpService.post<any>(`api/report/cash-account-balance`, data, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportCashAccountDistribution(data): Observable<any> {
    return this.httpService.post<any>(`api/report/cash-cad`, data, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportCashTrends(data): Observable<any> {
    return this.httpService.post<any>(`api/report/cash-trends`, data, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportCashSummary(data): Observable<any> {
    return this.httpService.post<any>(`api/report/cash-summary`, data, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportCashVendors(data): Observable<any> {
    return this.httpService.post<any>(`api/report/cash-vendors`, data, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportMembers(reportId): Observable<any> {
    return this.httpService.get<any>(`${this.REPORT_API_URL}-member/${reportId}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportAdmins(reportId): Observable<any> {
    return this.httpService.get<any>(`${this.REPORT_API_URL}-admin/${reportId}`, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportOwnerList(reportId, show_hidden_under_owner_id = null) {
    const data = {
      report_execution_id: reportId,
    };
    if (show_hidden_under_owner_id) {
      data['show_hidden_under_owner_id'] = true;
    }
    return this.httpService.post<any>(`${this.REPORT_API_URL}-execution-asset-map-owners`, data, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportByOwnerId(reportId, ownerId) {
    return this.httpService.get<any>(`${this.REPORT_API_URL}-execution-asset-map/${reportId}/${ownerId}`, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  createReportMember(request): Observable<any> {
    return this.httpService.post<any>(`${this.REPORT_API_URL}-member`, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateReportMember(request): Observable<any> {
    return this.httpService.patch<any>(`${this.REPORT_API_URL}-member`, request).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  deleteReportMember(reportMemberId): Observable<any> {
    return this.httpService.delete<any>(`${this.REPORT_API_URL}-member/${reportMemberId}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  createReportAdmin(request): Observable<any> {
    return this.httpService.post<any>(`${this.REPORT_API_URL}-admin`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteReportAdmin(reportMemberId): Observable<any> {
    return this.httpService.delete<any>(`${this.REPORT_API_URL}-admin/${reportMemberId}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  deleteReportForever(reportId): Observable<any> {
    return this.httpService.delete<any>(`${this.REPORT_API_URL}/${reportId}`).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }
  createReportSource(payload): Observable<any> {
    return this.httpService.post<any>(`${this.REPORT_API_URL}-source`, payload).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportJsonData(): Observable<any[]> {
    return this.http.get<any>('assets/json/report-config.json').pipe(
      map((Data) => {
        return Data;
      })
    );
  }
  getAllRules(id): Observable<any[]> {
    return this.httpService.get<any>(`api/report/report-rules/${id}`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  deleteRules(id): Observable<any> {
    return this.httpService.post<any>(`api/report/report-rules-delete`, id, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }
  createReportRule(payload) {
    return this.httpService.post<any>(`api/report/report-rules`, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  UpdateReportRule(payload) {
    return this.httpService.patch<any>(`api/report/report-rules`, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  SortReportRule(payload) {
    return this.httpService.post<any>(`api/report/report-rules-sort`, payload, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getBudget(id): Observable<any[]> {
    return this.httpService.get<any>(`api/report/report-budget/${id}`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  UpdateReportBudget(payload) {
    return this.httpService.post<any>(`api/report/report-budget`, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getCashAcountCount(id): Observable<any> {
    return this.httpService.get<any>(`api/report/cash-account-count/${id}`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getCashAcounts(id): Observable<any> {
    return this.httpService.get<any>(`api/report/cash-accounts/${id}`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateReportSourceAccountInclude(data) {
    const url = `api/report/report-source-account-add`;
    return this.httpService.patch<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  updateReportSourceAccountExclude(data) {
    const url = `api/report/report-source-account-remove`;
    return this.httpService.patch<serverResponceCashFlow>(url, data).pipe(
      map((response: serverResponceCashFlow) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  getBalanceLiquiditySummary(data): Observable<any> {
    return this.httpService.post<any>(`api/report/balance-liquidity-summary`, data, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getIncompleteForm(): Observable<any> {
    return this.httpService.get<any>(`api/onboarding/incomplete-forms-for-reports`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getRefreshReports(): Observable<any> {
    return this.httpService.get<any>(`api/report/refresh-reports`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  /**
   * Report group management
   */
  createReportGroup(body): Observable<any> {
    return this.httpService.post<any>(`api/report/report-group`, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateReportGroup(body): Observable<any> {
    return this.httpService.patch<any>(`api/report/report-group`, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportGroups(reportId: string): Observable<any> {
    return this.httpService.get<any>(`api/report/report-group/${reportId}`, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportBalanceTableData(reportId: string): Observable<any> {
    return this.httpService.get<any>(`api/report/report-balance-table/${reportId}`, loaderTypes.default).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteReportGroup(reportGroupId: string): Observable<any> {
    return this.httpService.delete<any>(`api/report/report-group/${reportGroupId}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createReportGroupUser(body): Observable<any> {
    return this.httpService.post<any>(`api/report/report-group-user`, body, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteReportGroupUser(reportGroupUserId: string): Observable<any> {
    return this.httpService.delete<any>(`api/report/report-group-user/${reportGroupUserId}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUnAddedReportVaults(reportId: number, userid: string, reportType: string): Observable<any> {
    return this.httpService.get<any>(`api/report/report-vault/${reportId}/${userid}`, loaderTypes.none).pipe(
      map((response: any) => {
        return response.data;
      })
    );
  }

  /**
   * Template counts
   */
  getReportOwnershipMapTemplateCount(reportExecutionId: string): Observable<any> {
    return this.httpService.get<any>(`api/report/report-ownership-map-template-count/${reportExecutionId}`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportBalanceTemplateCount(reportExecutionId: string): Observable<any> {
    return this.httpService.get<any>(`api/report/report-balance-template-count/${reportExecutionId}`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  /**
   * Owner counts
   */
  getReportOwnershipMapOwnerCount(reportExecutionId: string): Observable<any> {
    return this.httpService.get<any>(`api/report/report-ownership-map-owner-count/${reportExecutionId}`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportBalanceOwnerCount(reportExecutionId: string): Observable<any> {
    return this.httpService.get<any>(`api/report/report-balance-owner-count/${reportExecutionId}`, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportExecutionBalanceBoards(data): Observable<any> {
    return this.httpService.post<any>(`api/report/report-execution-balance-boards`, data, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportBalanceInvestableAsset(id): Observable<any> {
    return this.httpService.get<any>(`api/report/report-balance-investable-asset/${id}/6`, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getReportExecutionBalanceLiquidity(id): Observable<any> {
    return this.httpService.get<any>(`api/report/report-execution-balance-liquidity/${id}`, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
